const LowInStockStatusDot = `<svg width="8" height="8" viewBox="0 0 8 8" fill="none"
  xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8ZM1.3334 4.00002C1.3334 2.52726 2.52731 1.33335 4.00007 1.33335C5.47283 1.33335 6.66674 2.52726 6.66674 4.00002H1.3334Z" fill="#F26A2F"/>
</svg>`;
export default LowInStockStatusDot;
//# sourceMappingURL=LowInStockStatusDot.js.map